import React from 'react';

import {
  Box,
  Flex,
  Heading,
  useBreakpointValue,
  useToast,
  Center,
  Spinner,
  IconButton,
  Button,
} from '@chakra-ui/react';
import { FaArrowLeft } from 'react-icons/fa';
import { Link, useHistory, useParams } from 'react-router-dom';

import {
  Badge,
  Header,
  HeaderLeftAction,
  HeaderRightAction,
  HeaderTitle,
} from '@/components';
import { Page, AppFooter } from '@/layout';
import { useAppointment } from '@/services/appointments';

import { AppointmentAgencyDetail } from './_partials/AppointmentAgencyDetail';
import { AppointmentInformation } from './_partials/AppointmentInformation';

export const AppointmentDetail = () => {
  const isWide = useBreakpointValue({ base: false, md: true });
  const toast = useToast();
  const { agendaId: appointmentId } = useParams();
  const history = useHistory();
  const { data: appointmentDetail, isLoading, isSuccess } = useAppointment({
    params: { appointmentId },
    onError: (err) => {
      if (err.response.status === 403) {
        return;
      }
      toast({
        title: 'Une erreur est survenue lors de la recherche de rendez-vous',
        status: 'error',
      });
    },
  });

  return (
    <Page
      px="0"
      pb={2}
      overflowX="hidden"
      background="url('/images/wave.svg') top center no-repeat"
      backgroundColor="gray.100"
      backgroundSize="contain"
      position="relative"
    >
      <Header position="fixed">
        <Box maxWidth="45em" position="relative" width="100%" h="100%">
          <HeaderLeftAction>
            <IconButton
              onClick={() => history.push('/agenda')}
              colorScheme="gray"
              color="gray.400"
              variant="ghost"
              icon={<FaArrowLeft />}
            />
          </HeaderLeftAction>

          <HeaderTitle>Détails du rendez-vous</HeaderTitle>
          <HeaderRightAction />
        </Box>
      </Header>

      <Box position="relative">
        <Flex
          mt="5"
          flexGrow="1"
          px={2}
          flexDirection="column"
          w="100%"
          maxWidth="45em"
          mx="auto"
        >
          <Flex px="2" justifyContent="space-between" alignItems="center">
            <Heading as="h2" size="lg">
              Votre demande
            </Heading>
          </Flex>
          <Box position="relative" px="2" py={{ base: 20, md: 0 }}>
            <Box
              as="img"
              src="/images/greenWomen.svg"
              alt=""
              position="absolute"
              top={{ base: 0, md: '3vw' }}
              right={{ base: 0, md: '-13vw' }}
            />
            <Box
              d={{ base: 'none', md: 'block' }}
              as="img"
              src="/images/grid.svg"
              alt=""
              position="absolute"
              top="8vw"
              left="-13vw"
            />
          </Box>
          {isLoading && (
            <Center>
              <Spinner
                thickness="4px"
                emptyColor="gray.200"
                color="brandSecondary.600"
                size="xl"
              />
            </Center>
          )}
          {!isLoading && isSuccess && !appointmentDetail && (
            <Center h={40} flexDir="column">
              <Badge
                textAlign="center"
                size="lg"
                mt={10}
                py={4}
                colorScheme="warning"
              >
                Vous ne pouvez pas accéder à ce rendez-vous
              </Badge>
              <Button
                as={Link}
                variant="link"
                to="/bookings"
                colorScheme="brandSecondary"
                mt={4}
              >
                Retournez vers la liste des rendez-vous
              </Button>
            </Center>
          )}
          {!!appointmentDetail && (
            <>
              <AppointmentInformation appointment={appointmentDetail} />
              {!!appointmentDetail?.agency && (
                <AppointmentAgencyDetail
                  appointmentAgency={appointmentDetail?.agency}
                  mt={4}
                />
              )}
            </>
          )}
        </Flex>
      </Box>

      {!isWide ? <AppFooter /> : null}
    </Page>
  );
};
